import script from "./SuggestionBox.vue?vue&type=script&setup=true&lang=js"
export * from "./SuggestionBox.vue?vue&type=script&setup=true&lang=js"

import "./SuggestionBox.vue?vue&type=style&index=0&id=5494885b&lang=scss"

const __exports__ = script;

export default __exports__